export default "__VITE_ASSET__DJA9orvx__"